module.exports = __webpack_public_path__ + "static/media/movimenti.13e04cb3.svg";